import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=c6db2534"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSelect.vue?vue&type=style&index=0&id=c6db2534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports